import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../../components/ui/button';

const DX_LOGO_URL = 'https://cdn.art-mate.net/uploads/artmate/202502/thumbnail/20250228_160227_1YqJgAgCUS_p_300_0.png';

const LanguageSelect = () => {
  const { setLanguage, setAgeCategory } = useLanguage();
  const navigate = useNavigate();

  const [selectedLanguage, setSelectedLanguage] = React.useState(null);
  const [selectedAge, setSelectedAge] = React.useState(null);

  const languages = [
    { code: 'en', label: '英文', native: 'English' },
    { code: 'tc', label: 'Traditional Chinese', native: '繁體中文' },
    { code: 'sc', label: 'Simplified Chinese', native: '简体中文' },
  ];

  const ageCategories = [
    { code: 'children', label: { en: 'Children', tc: '兒童', sc: '儿童' } },
    { code: 'adult', label: { en: 'Adult', tc: '成人', sc: '成人' } },
    { code: 'elder', label: { en: 'Elder', tc: '長者', sc: '长者' } },
  ];

  const handleLanguageClick = (lang) => {
    setLanguage(lang);
    setSelectedLanguage(lang);
  };

  const handleAgeClick = (age) => {
    setAgeCategory(age);
    setSelectedAge(age);
  };

  const handleContinue = () => {
    const redirectPath = localStorage.getItem('redirectPath');
    localStorage.removeItem('redirectPath');
    navigate(redirectPath || '/qr-instructions');
  };

  const getTranslation = (key) => {
    const translations = {
      title: { en: 'Digital Exhibition Guide', tc: '數碼展品導覽', sc: '数码展品导览' },
      selectLanguage: { en: 'Select your language', tc: '選擇您的語言', sc: '选择您的语言' },
      selectAge: { en: 'Select your age category', tc: '選擇您的年齡類別', sc: '选择您的年龄类别' },
      continue: { en: 'Continue', tc: '繼續', sc: '继续' },
      ageNote: { 
        en: 'This helps us optimize text size and audio speed for you', 
        tc: '這有助我們為您優化文字大小和音訊速度', 
        sc: '这有助我们为您优化文字大小和音频速度' 
      },
    };
    
    return translations[key]?.[selectedLanguage || 'en'] || '';
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black px-4">
      <div className="max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="flex flex-col items-center space-y-4" data-testid="welcome-header">
          <img 
            src={DX_LOGO_URL} 
            alt="DX Logo" 
            className="w-32 h-32 object-contain"
          />
          <div className="text-center space-y-1">
            <h1 className="text-2xl font-heading font-bold tracking-tight text-white">
              Digital Exhibition Guide
            </h1>
            <p className="text-lg text-white/80">
              數碼展品導覽
            </p>
          </div>
        </div>

        {/* Language Selection */}
        {!selectedLanguage && (
          <div className="space-y-4" data-testid="language-selection">
            <p className="text-center text-lg text-white/80 font-medium">
              Select your language<br/>
              <span className="text-white/60">請選擇語言</span>
            </p>
            <div className="space-y-3">
              {languages.map((lang) => (
                <Button
                  key={lang.code}
                  onClick={() => handleLanguageClick(lang.code)}
                  variant="outline"
                  className="w-full h-16 text-left justify-start bg-white/5 border-white/20 hover:bg-white/10 hover:border-white/40 transition-all"
                  data-testid={`language-btn-${lang.code}`}
                >
                  <div className="flex flex-col">
                    <span className="text-lg font-medium text-white">{lang.native}</span>
                    <span className="text-sm text-white/60">{lang.label}</span>
                  </div>
                </Button>
              ))}
            </div>
          </div>
        )}

        {/* Age Category Selection */}
        {/* {selectedLanguage && !selectedAge && (
          <div className="space-y-4" data-testid="age-selection">
            <div className="flex flex-col items-center gap-2">
              <p className="text-center text-lg text-white font-medium">
                {getTranslation('selectAge')}
              </p>
              <p className="text-center text-sm text-white/60">
                {getTranslation('ageNote')}
              </p>
            </div>
            <div className="space-y-3">
              {ageCategories.map((age) => (
                <Button
                  key={age.code}
                  onClick={() => handleAgeClick(age.code)}
                  variant="outline"
                  className="w-full h-16 text-center justify-center bg-white/5 border-white/20 hover:bg-white/10 hover:border-white/40 transition-all"
                  data-testid={`age-btn-${age.code}`}
                >
                  <span className="text-xl font-medium text-white">{age.label[selectedLanguage]}</span>
                </Button>
              ))}
            </div>
            <div className="text-center pt-2">
              <Button
                onClick={() => setSelectedLanguage(null)}
                variant="ghost"
                size="sm"
                className="text-white/60 hover:text-white hover:bg-white/10"
              >
                ← {getTranslation('selectLanguage')}
              </Button>
            </div>
          </div>
        )} */}

        {/* Continue Button */}
        {/* {selectedLanguage && selectedAge && ( */}
        {selectedLanguage && (
          <div className="space-y-4" data-testid="continue-section">
            <div className="text-center space-y-2 p-6 bg-white/5 rounded-xl border border-white/20">
              <p className="text-sm text-white/60">
                {selectedLanguage === 'en' ? 'Language:' : selectedLanguage === 'tc' ? '語言：' : '语言：'}
              </p>
              <p className="text-lg font-semibold text-white">
                {languages.find(l => l.code === selectedLanguage)?.native}
              </p>
              {/* <p className="text-sm text-white/60 mt-3">
                {selectedLanguage === 'en' ? 'Age Category:' : selectedLanguage === 'tc' ? '年齡類別：' : '年龄类别：'}
              </p>
              <p className="text-lg font-semibold text-white">
                {ageCategories.find(a => a.code === selectedAge)?.label[selectedLanguage]}
              </p> */}
            </div>
            <Button
              onClick={handleContinue}
              className="w-full h-14 text-lg bg-white text-black hover:bg-white/90"
              data-testid="continue-button"
            >
              {getTranslation('continue')} →
            </Button>
            {/* <div className="text-center">
              <Button
                onClick={() => setSelectedAge(null)}
                variant="ghost"
                size="sm"
                className="text-white/60 hover:text-white hover:bg-white/10"
              >
                ← {getTranslation('selectAge')}
              </Button>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelect;
